import { booleanAttribute, Component, ElementRef, inject, Input } from '@angular/core';
import { IconComponent } from "@shared/ui-components/icon/icon.component";
import { Router } from '@angular/router';
import { NavigationHelper } from '@app/shared/utils/nav/nav-helper';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InfoMessageComponent } from '@app/shared/ui-components/info-message/info-message.component';
import { InfoMessageType } from '@app/shared/ui-components/info-message/InfoMessageType';


@Component({
    selector: 'app-header-toolbar',
    imports: [CommonModule, IconComponent, TranslateModule,InfoMessageComponent],
    templateUrl: './header-toolbar.component.html',
    styleUrl: './header-toolbar.component.scss'
})
export class HeaderToolbarComponent {
  private readonly router: Router = inject(Router);
  private navigationService = inject(NavigationService);
  public readonly elementRef = inject(ElementRef);

  public infoMessageTypes = InfoMessageType;

  @Input() urlPath?: string;
  @Input() expanded: boolean = false;
  @Input({ transform: booleanAttribute }) headerOnly: boolean = false;

  public pageTitle = this.navigationService.getPageName();
  public onMaintenance =this.navigationService.maintainMode;
  

  onNavigateAction() {
    NavigationHelper.navigateTo(this.router, this.urlPath ?? '/');
  }

  toggleExpand(): void {
    this.expanded = !this.expanded;
  }


}
